<script setup lang="ts">
import { useGameStore } from '@/stores/gameStore'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const gameStore = useGameStore()

const percentageUsed = computed(() => {
  if (gameStore.hoursOnlineLimit === 0) return 0
  return (gameStore.hoursOnline / gameStore.hoursOnlineLimit) * 100
})

const clockIcon = computed(() => {
  const pct = percentageUsed.value
  if (pct < 50) return { icon: 'clock_loader_10', color: 'text-green-700', fill: 1 }
  if (pct < 80) return { icon: 'clock_loader_40', color: 'text-yellow-700', fill: 0 }
  if (pct < 90) return { icon: 'clock_loader_80', color: 'text-yellow-700', fill: 0 }
  return { icon: 'clock_loader_90', color: 'text-red-500', fill: 1 }
})

const showHoursOnlineModal = () => {
  gameStore.showModal('hoursOnline')
}
</script>

<template>
  <div class="pr-2 pt-1 cursor-pointer" @click="showHoursOnlineModal">
    <span
      class="material-symbols-outlined"
      :class="clockIcon.color"
      :style="{ fontVariationSettings: `'FILL' ${clockIcon.fill}, 'wght' 400, 'GRAD' 0, 'opsz' 24` }"
      :title="t('game.hoursOnline.tooltip', { current: gameStore.hoursOnline, limit: gameStore.hoursOnlineLimit })"
    >
      {{ clockIcon.icon }}
    </span>
  </div>
</template>

<style scoped lang="scss"></style>
